import { render, staticRenderFns } from "./error-layout.vue?vue&type=template&id=c0e7a334&scoped=true&"
import script from "./error-layout.vue?vue&type=script&lang=js&"
export * from "./error-layout.vue?vue&type=script&lang=js&"
import style0 from "./error-layout.vue?vue&type=style&index=0&id=c0e7a334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e7a334",
  null
  
)

export default component.exports